import type { InjectionKey, Ref } from "vue";

export interface EbzNavMenuContext {
  active: Ref<boolean>;
}

export const EBZ_NAV_MENU = Symbol(
  "EbzNavMenu"
) as InjectionKey<EbzNavMenuContext>;
